'use client'

import { usePathname } from 'next/navigation'

// Note: footerHtml is admin-only content set by super_admin via the branding settings.
// It is not user-supplied input. Only super_admin can set this value.
interface FooterProps {
  footerLogoUrl: string | null
  footerHtml: string | null
}

export default function SiteFooter({ footerLogoUrl, footerHtml }: FooterProps) {
  const pathname = usePathname()

  // Dashboard is a full-screen app — the footer would steal viewport space and conflict
  // with the sidebar's fixed height. Only show on non-dashboard routes.
  // /onboard is the customer-facing onboarding page: Charleston Telecom Solutions branding only, never the platform footer.
  if (pathname?.startsWith('/dashboard') || pathname?.startsWith('/onboard') || pathname === '/status') return null
  if (!footerLogoUrl && !footerHtml) return null

  return (
    <footer className="w-full border-t border-brand-border mt-auto" style={{ background: 'var(--brand-bg-surface)' }}>
      <div className="flex items-center justify-between px-6 py-4 gap-4">
        <div>
          {footerLogoUrl && (
            <img src={footerLogoUrl} alt="Footer Logo" className="h-8 object-contain object-left" />
          )}
        </div>
        <div className="text-sm text-[var(--brand-text-muted)]">
          {footerHtml && (
            // eslint-disable-next-line react/no-danger
            <div dangerouslySetInnerHTML={{ __html: footerHtml }} />
          )}
        </div>
      </div>
    </footer>
  )
}
